import React, { useContext, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { FormContextProvider, TabPanelContext, TabPanelContextProvider } from "../../context/ContextIndex";
import { AppFormRootContainer, TabPanel } from "../../components";
import PezodeCreate from "./pezode/create/PezodeCreate";
import PezodeList from "./pezode/list/PezodeList";
import { getPezodeDefaultValue, getPezodeSchema } from "./pezode/create/schema";
import PezodeRangeView from "./pezode-range/PezodeRangeView";
import PezodeProductView from "./pezode-product/PezodeProductView";

const PezodeGroupView = ({ displayList }) => {
    return displayList ? (
        <PezodeList />
    ) : (
        <TabPanelContextProvider>
            <AppFormRootContainer>
                <PezodeTabContent />
            </AppFormRootContainer>
        </TabPanelContextProvider>
    );
};

const PezodeTabContent = () => {
    const { t } = useTranslation();
    const pezodeRef = useRef();
    const _tabContextObject = useContext(TabPanelContext);
    const _tabContext = _tabContextObject.getTabFormContext();

    const pezodeDefaultValue = getPezodeDefaultValue(_tabContext.data?.pezodein);
    const [pezodeFormData, setPezodeFormData] = useState({
        pezodeSchema: getPezodeSchema({
            location: [],
            zone: [],
            pest: [],
            device: [],
            inputUnit: [],
            iCabsProductCode: [],
            iCabsProductDetails: [],
            infestationLevel: []
        }),
        appformdata: null,
    });

    const handleTabChange = (newTab) => {
        try {
            if (_tabContext.tabIndex === "0" && pezodeRef.current) {
                pezodeRef.current.tabChangeHandler(newTab);
            } else if (
                (_tabContext.tabIndex === "1" &&
                    (newTab === "0" ||
                        (newTab === "2" &&
                            _tabContext?.data?.pezoderange?.length > 0 &&
                            _tabContext?.isValid))) ||
                _tabContext.tabIndex === "2"
            ) {
                _tabContextObject.setTabFormContext({ tabIndex: newTab });
            }
        } catch (e) {
            alert(e);
        }
    };

    return (
        <TabPanel
            tabs={[
                {
                    icon: "",
                    label: t("pezodeList.header"),
                    children: (
                        <FormContextProvider
                            schema={pezodeFormData.pezodeSchema}
                            defaultValues={pezodeDefaultValue}
                            appformdata={pezodeFormData?.appformdata}
                        >
                            <PezodeCreate
                                ref={pezodeRef}
                                setPezodeFormData={setPezodeFormData}
                                setIsFormValid
                            />
                        </FormContextProvider>
                    ),
                },
                {
                    icon: "",
                    label: t("navigationMenu.range"),
                    children: <PezodeRangeView />,
                },
                {
                    icon: "",
                    label: t("navigationMenu.products"),
                    children: <PezodeProductView />,
                }
            ]}
            selectedTab={_tabContext.tabIndex}
            onTabChange={handleTabChange}
        />
    );
};

export default PezodeGroupView;
